export enum ActionTypeEnum {
  CREATE = 0, // создание смены
  UPDATE = 1, // обновление смен /смены
  DELETE = 2, // удаление смен/смены
  GENERATION = 3, // генерация смен
  CREATEABSENCE = 4, // создание отсутствия
  UPDATEABSENCE = 5, // обновление отсутствия
  DELETEABSENCE = 6, // удаление отсутствия
  CREATETASK = 7, // создание наряда
  DEPARTMENTCHANGEDINTASK = 8, // изменение участка в наряде
  PERSONCHANGEDINTASK = 9, // изменение исполнителя в наряде (не используется сейчас)
  DELETETASK = 10 // удаление наряда
}

export interface LogsItem {
  id: string;
  actionType: ActionTypeEnum;
  changedBy: string;
  changedByUserId: number;
  actionDate: string;
  department: string;
  departmentId: number;
  startDate: string;
  endDate: string;
  person: string;
  personId: number;
  added?: ShiftChange[] | AbsenceChange[] | TaskChange[] | TaskChange;
  deleted?: ShiftChange[] | AbsenceChange[] | TaskChange[] | TaskChange;
}

export interface ShiftChange {
  id: number;
  personId: number;
  departmentId: number;
  start?: string;
  end?: string;
  date?: string; // Для некоторых записей используется date вместо start
  workdayStart: string;
  workdayDuration: string;
  breakDuration: string;
}

export interface AbsenceChange {
  id: number;
  from: string;
  to: string;
  personId: number;
  departmentId: number;
  absence: {
    id: number;
    label: string;
    shortName: string;
    shouldRemoveShift: boolean;
  };
}

export interface TaskChange {
  id?: number;
  taskId: number;
  taskName?: string;
  name?: string;
  departmentId: number;
  department?: string;
  employees?: string[];
  actualStartDate?: string;
  plannedEndDate?: string;
  endDate?: string;
  startDate?: string;
  actualEndDate?: string;
  description?: string;
  isDeleted?: boolean;
}

export interface Log {
    id: number,
    date: string,
    platform: string
}